import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";

/**
 * Prepares a shipment for repeating by clearing stale values that should be
 * re-entered for the new shipment.
 *
 * - Deadlines are cleared because they're date-specific and the old deadline
 *   may be before the new pickup date
 * - Booth numbers are cleared because trade show booths change between shipments
 */
export function viewShipmentsPrepareShipmentForRepeat(
  shipment: Shipment,
  newPickupDate: string,
): Shipment {
  const repeated: Shipment = {
    ...shipment,
    pickupDate: newPickupDate,
    deliveryBoothNumber: "",
    pickupBoothNumber: "",
  };
  // Clear deadlines (date-specific) rather than assigning undefined, which
  // exactOptionalPropertyTypes disallows for these optional fields.
  delete repeated.deliveryDeadline;
  delete repeated.pickupDeadline;
  return repeated;
}
